<nz-page-header nzTitle="Underwriter Agent List"></nz-page-header>

<a [routerLink]="['/agent/underwriter/new']" nz-button nzType="dashed" class="mb-1" >+ New Agent</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<tbody>
		<tr *ngFor="let item of data">
			<td>
				<a [routerLink]="['/agent/underwriter',item.id,'edit']" class="btn btn-sm btn-secondary">Open</a>
			</td>
			<td>{{item.username}}</td>
			<td>{{item.firstName}}</td>
			<td>{{item.lastName}}</td>
		</tr>
	</tbody>
</nz-table>
